import { useRevealClass } from '../../hooks/useRevealClass'

/**
 * Scroll-reveal wrapper mirroring the `.reveal` behaviour from the original
 * static pages. Renders as `as` (default div) and toggles `is-visible` when the
 * element scrolls into view. Staggering between siblings is handled by
 * useRevealClass.
 */
export default function Reveal({ as: Tag = 'div', className = '', variant = 'reveal', style, children, ...rest }) {
  const { ref, visible } = useRevealClass()
  return (
    <Tag
      ref={ref}
      className={`${variant} ${className}${visible ? ' is-visible' : ''}`.trim()}
      style={style}
      {...rest}
    >
      {children}
    </Tag>
  )
}
